/* eslint-disable camelcase */
import { useEffect, useState } from 'react';

import {
  getDataFromDomElement,
  useGlobalQueries,
} from '@/exceed';

export default ({ connect, disconnect, objectiveableId, onCloseChatExtraActions = () => {} }) => {
  const [intellumTutorAPI, setIntellumTutorAPI] = useState(null);
  const [intellumTutorStatus, setIntellumTutorStatus] = useState('closed');
  const { currentProfile } = useGlobalQueries();

  useEffect(() => {
    window.IntellumTutor?.({
      key: 'learning_objectives',
      onLoad: setIntellumTutorAPI,
      onStatusChange: setIntellumTutorStatus,
      renderElement: document.getElementById('intellum_tutor_learning_objectives'),
    });
  }, []);

  const openChat = () => {
    const dataFromDomElement = getDataFromDomElement('data-course-ai-learning-objectives');
    const courseCurriculumId = dataFromDomElement?.courseCurriculumId;
    const hasCourseCurriculumId = Boolean(courseCurriculumId);
    let ai_context = `Course::${objectiveableId}`;

    if (hasCourseCurriculumId) {
      ai_context += `,CourseCurriculum::${courseCurriculumId}`;
    }

    intellumTutorAPI?.setHandlers({
      onCloseChat: () => {
        disconnect();
        onCloseChatExtraActions();
      },
      onOpenChat: () => {
        connect();
      },
    });
    intellumTutorAPI?.openChat({
      ai_model: 'learning_objectives_chat',
      ai_context,
      exceed_user_id: currentProfile.data.id,
    });
  };
  
  return {
    intellumTutorStatus,
    hasIntellumTutorAPILoaded: Boolean(intellumTutorAPI),
    openChat,
  }
}
